import Reveal from './Reveal';

const personas = [
  {
    label: 'Power Traders',
    line: 'Active sellers who also buy, source and resell, and the brokers who do it for a living. Every supplier’s book in one place, your sources kept to yourself.',
  },
  {
    label: 'Sellers',
    line: 'Sell to your own buyers and through your brokers, from one menu, and see what landed.',
  },
  {
    label: 'Buyers',
    line: 'Complete, lab-backed listings from the sellers you already work with. Free.',
  },
];

const PersonaColumns = () => (
  <section id="who" className="scroll-mt-16 border-b border-border bg-subtle py-20 md:py-24">
    <div className="container-wide">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
          For power traders, sellers and buyers
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {personas.map((p, i) => (
          <Reveal key={p.label} delay={i * 90}>
            <div className="h-full rounded-xl border border-border bg-card p-7">
              <p className="text-sm font-semibold uppercase tracking-wide text-brand-text">{p.label}</p>
              <p className="mt-3 text-base text-muted-foreground">{p.line}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default PersonaColumns;
